import { useCallback, useState } from "react";

const STORAGE_KEY = "autoappy_current_workspace_id";

/**
 * Persists the selected workspace id to localStorage.
 */
export function useCurrentWorkspaceId() {
  const [currentWorkspaceId, setCurrentWorkspaceIdState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  });

  const setCurrentWorkspaceId = useCallback((id) => {
    setCurrentWorkspaceIdState(id);
    try {
      if (id) {
        localStorage.setItem(STORAGE_KEY, id);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
    }
  }, []);

  return [currentWorkspaceId, setCurrentWorkspaceId];
}
